import { render, staticRenderFns } from "./CadastroConfiguracaoVendaPrazos.vue?vue&type=template&id=1dbc87ac"
import script from "./CadastroConfiguracaoVendaPrazos.vue?vue&type=script&lang=js"
export * from "./CadastroConfiguracaoVendaPrazos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports